import { Directive, AfterViewInit, ElementRef, Renderer2 } from '@angular/core';
import { DropDownListComponent } from '@progress/kendo-angular-dropdowns';
import { KeyCodes } from '@app/shared/key-codes';

// TODO: kendo-dropdownlist should opens by enter itself
@Directive({
  standalone: false,
  selector: 'kendo-dropdownlist', // eslint-disable-line @angular-eslint/directive-selector
})
export class KendoDropDownEnterPressDirective implements AfterViewInit {
  private isOpen = false;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private host: DropDownListComponent,
  ) {}

  ngAfterViewInit() {
    const el = this.elementRef.nativeElement;

    this.renderer.listen(el, 'keydown', (event) => {
      if (event.keyCode === KeyCodes.enter) {
        !this.isOpen ? el.click() : this.host.toggle(false);
        this.isOpen = !this.isOpen;
      }
    });
  }
}
